import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import TextAreaAHSF from "../../Components/TextAreaAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  GetStepsAction,
  SetStepsAction,
  UpdateStepsAction,
} from "../../Redux/Reducers/StepsAction";

const RecommendationMainTask = (props) => {
  const dispatch = useDispatch();
  const [list, setList] = useState();
  const state = useSelector((state) => ({
    StepsAction: state.StepsAction.StepsAction,
  }));
  const getData = async () => {
    let data = await dispatch(GetStepsAction(props.taskId));
    setList(data.payload);
  };
  useEffect(() => {
    getData();
  }, []);
//to set data resone on state
  useEffect(() => {
    dispatch(SetStepsAction({ ...list }));
  }, [list]);
  console.log(state.StepsAction, "StepsAction");
  const update = (action) => {
    dispatch(
      UpdateStepsAction({
        wF_StepsActionGuid: action.wF_StepsActionGuid,
        statementReasons: action.statementReasons,
        actionType: action.actionType,
        taskFlowGUID: action.taskFlowGUID,
      })
    );
  };
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="توصية"
        child={[
          <div className="form-gridScound">
            {/* Text Area Component */}
            <TextAreaAHSF
              fieldsName="comments"
              show={true}
              disabled={props.disabled}
                defaultValue={list?.statementReasons}
              onChange={(e) => {
                setList({ ...list, statementReasons: e.target.value });
                //   update();
              }}
              onBlur={(e) => {
                // setlistt({ ...listt, recommendationReason: e.target.value });
                // updateList(listt);
              }}
            />
          </div>,
        ]}
      />
    </>
  );
};
export default RecommendationMainTask;
